import { useIntl } from 'react-intl';
import { IconGripVertical, IconTrash } from '@rossum/ui/icons/tabler';
import {
  Box,
  Card,
  IconButton,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { DragHandleProps } from '../../../../../../../../../decorators/SortableWrapper/SortableWrapper';
import { HeaderFieldFormModel } from '../utils';

type LineItemColumnCardProps = {
  columnModel: HeaderFieldFormModel;
  disabled?: boolean;
  isDragging?: boolean;
  dragHandleProps?: DragHandleProps | null;
  onClick?: () => void;
  onDelete?: () => void;
};

const LineItemColumnCard = ({
  columnModel,
  disabled,
  isDragging,
  dragHandleProps,
  onClick,
  onDelete,
}: LineItemColumnCardProps) => {
  const intl = useIntl();

  return (
    <Card
      elevation={8}
      sx={{
        my: 0.5,
        px: 1,
        py: 0.5,
        ':hover': {
          backgroundImage:
            'linear-gradient(rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.14))',
        },
        cursor:
          disabled && !isDragging
            ? 'not-allowed'
            : isDragging
              ? 'grabbing'
              : 'pointer',
        borderRadius: borderRadius('s'),
      }}
      onClick={() => !disabled && onClick?.()}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(24, 1fr)"
        gap={2}
        alignItems="center"
      >
        <Box gridColumn="span 1">
          <Typography
            variant="body2"
            color="text.disabled"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <IconButton
              size="small"
              color="inherit"
              disabled={disabled}
              aria-disabled={disabled}
              disableRipple
              aria-label={intl.formatMessage({
                id: 'components.lineItemColumnCard.dragIndicator.label',
              })}
              title={intl.formatMessage({
                id: 'components.lineItemColumnCard.dragIndicator.label',
              })}
              sx={{
                cursor: 'grab',
              }}
              {...dragHandleProps?.listeners}
              {...dragHandleProps?.attributes}
            >
              <SvgIcon fontSize="medium">
                <IconGripVertical />
              </SvgIcon>
            </IconButton>
          </Typography>
        </Box>
        <Box gridColumn="span 9">
          <Typography variant="body2">{columnModel.label}</Typography>
        </Box>
        <Box gridColumn="span 12">
          <Typography noWrap variant="body2" color="text.disabled">
            {columnModel.engineOutputId}
          </Typography>
        </Box>
        <Box gridColumn="span 2">
          <Typography variant="body2" color="text.disabled">
            <IconButton
              size="small"
              color="inherit"
              onClick={e => {
                e.stopPropagation();
                onDelete?.();
              }}
              disabled={disabled}
              aria-disabled={disabled}
              aria-label={intl.formatMessage({
                id: 'components.lineItemColumnCard.delete.label',
              })}
              title={intl.formatMessage({
                id: 'components.lineItemColumnCard.delete.label',
              })}
            >
              <SvgIcon fontSize="inherit">
                <IconTrash />
              </SvgIcon>
            </IconButton>
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export { LineItemColumnCard };
